var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShowPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 10.172C12.3363 10.172 10.172 12.3363 10.172 15C10.172 17.6637 12.3363 19.828 15 19.828C17.6637 19.828 19.828 17.6637 19.828 15C19.828 12.3363 17.6637 10.172 15 10.172ZM14.6337 13.5682C14.0344 13.5682 13.5349 14.0677 13.5349 14.667H11.9367C11.97 13.1687 13.1687 11.97 14.6337 11.97V13.5682Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6504 14.001C28.0189 11.97 22.192 5.34399 15 5.34399C7.80799 5.34399 1.98113 11.97 0.349612 14.001C-0.116537 14.5671 -0.116537 15.3995 0.349612 15.9988C1.98113 18.0299 7.80799 24.6559 15 24.6559C22.192 24.6559 28.0189 18.0299 29.6504 15.9988C30.1165 15.4328 30.1165 14.6004 29.6504 14.001ZM15 21.9922C11.1376 21.9922 8.00777 18.8623 8.00777 14.9999C8.00777 11.1376 11.1376 8.0077 15 8.0077C18.8624 8.0077 21.9922 11.1376 21.9922 14.9999C21.9922 18.8623 18.8624 21.9922 15 21.9922Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/showPassword.e0f45188d36e5b2465043efde277e6e2.svg";
export { ForwardRef as ReactComponent };